var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-login"},[_c('div',{staticClass:"wrap"},[_c('CtrlLogin')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }